import { jsx as o } from "react/jsx-runtime";
const s = (l) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "M32 32c7.18 0 13-5.82 13-13S39.18 6 32 6s-13 5.82-13 13 5.82 13 13 13Zm0-22c4.96 0 9 4.04 9 9s-4.04 9-9 9-9-4.04-9-9 4.04-9 9-9ZM58 52.93V40.39L32 33.5 6 40.39v13.6C6 56.2 7.79 58 10 58h45.07L54 54H10V43.47l22-5.83 22 5.83V54l4-1.07Z"
      }
    )
  }
);
export {
  s as Customer
};
